import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideTranslateService, TranslateDirective, TranslateLoader, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ClipboardModule } from 'ngx-clipboard';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BannerComponent } from './components/banner/banner.component';
import { FaqComponent } from './components/faq/faq.component';
import { FeatureComponent } from './components/feature/feature.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { LanguageComponent } from './components/language/language.component';
import { RoundAndUserDetails } from './components/round-and-user-details/round-user-details.component';
import { ScrollerComponent } from './components/scroller/scroller.component';
import { StakingComponent } from './components/staking/staking.component';
import { SwapComponent } from './components/swap/swap.component';
import { Widget } from './components/widget/widget.component';
import { BestwalletComponent } from './modals/bestwallet/bestwallet.component';
import { ClaimComponent } from './modals/claim/claim.component';
import { ConnectComponent } from './modals/connect/connect.component';
import { NoWalletComponent } from './modals/no-wallet/no-wallet.component';
import { ReferComponent } from './modals/refer/refer.component';
import { WertComponent } from './modals/wert/wert.component';
import { SharedModule } from './shared/shared.module';
import { BuyETHWertComponent } from './modals/eth-buy-wert/buy-eth-wert.component';
import { HowToBuyComponent } from './components/how-to-buy/how-to-buy.component';
import { AboutComponent } from './components/about/about.component';
import { TokenomicsComponent } from './components/tokenomics/tokenomics.component';
import { RoadmapComponent } from './components/roadmap/roadmap.component';
import { NotifLibraryModule } from 'notif-library';
import { NotificationPurchaseComponent } from './components/notification-purchase/notification-purchase.component';

@NgModule({
  declarations: [
    AppComponent,
    BannerComponent,
    SwapComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    LanguageComponent,
    NoWalletComponent,
    ConnectComponent,
    ClaimComponent,
    ReferComponent,
    WertComponent,
    ScrollerComponent,
    StakingComponent,
    FeatureComponent,
    FaqComponent,
    BestwalletComponent,
    RoundAndUserDetails,  // This component is used to show the Round timer, User purchased details, Round title etc
    Widget,             // This widget uses new buy flow. Buy with Card and Buy with Crypto,
    BuyETHWertComponent,
    HowToBuyComponent,
    AboutComponent,
    TokenomicsComponent,
    RoadmapComponent,
    NotificationPurchaseComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    NgxChartsModule,
    SharedModule,
    TranslatePipe,
    TranslateDirective,
    CarouselModule,
    AccordionModule,
    ClipboardModule,
    NotifLibraryModule,
    ModalModule.forRoot(),
    AngularSvgIconModule.forRoot(),
    BsDropdownModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      disableTimeOut: false,
      progressBar: true,
      progressAnimation: 'decreasing',
      maxOpened: 1,
    }),
  ],
  providers: [
    provideHttpClient(withFetch()),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    provideClientHydration(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
